import { render, staticRenderFns } from "./applyneedknow.vue?vue&type=template&id=a7247aea&"
import script from "./applyneedknow.vue?vue&type=script&lang=js&"
export * from "./applyneedknow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports